/* global jQuery */
const $ = jQuery;

$(document).ready(() => {
    $('.woocommerce-shipping-fields input[type=radio]').on('click', function (e) {
        let previousValue = $(this).data('storedValue');

        if (previousValue) {
            $(this).prop('checked', !previousValue);
            $(this).data('storedValue', !previousValue);
        } else {
            $(this).data('storedValue', true);
            $('.woocommerce-shipping-fields input[type=radio]:not(:checked)').data('storedValue', false);
        }

        if ($(this).val() === '1' && e.currentTarget.checked) {
            $('.shipping_address').show();
        } else {
            $('.shipping_address').hide();
        }

        if ($(this).val() === '' && e.currentTarget.checked && $(e.currentTarget).is('#js-billing-pdf')) {
            $('#order_invoice_email_field').show();
        } else {
            $('#order_invoice_email_field').hide();
            $('#order_invoice_email_field input').val('');
        }

        if ($(this).val() === '' && e.currentTarget.checked && $(e.currentTarget).is('#js-billing-electronic')) {
            $('#order_company_e_reference_field').show();
            $('#order_company_gln_field').show();
            $('#order_company_is_einvoice').val('1');
        } else {
            $('#order_company_e_reference_field').hide();
            $('#order_company_gln_field').hide();
            $('#order_company_e_reference_field input').val('');
            $('#order_company_gln_field input').val('');
            $('#order_company_is_einvoice').val('0');
        }
    });

    $('#billing_company_position').on('change', function (e) {
        if ($(this).val() == 'other') {
            $('#billing_company_position_extra_field').show();
        } else {
            $('#billing_company_position_extra_field').hide();
        }
    });

});
